
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class FreeProductPlanSettingDtoModel extends Model<FreeProductPlanSettingDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'sourceTag', type: 'string', languageString: 'freeProductPlanSettingDto.property.sourceTag' },
		{ name: 'destinationTag', type: 'string', languageString: 'freeProductPlanSettingDto.property.destinationTag' },
		{ name: 'amount', type: 'number', languageString: 'freeProductPlanSettingDto.property.amount' }
	];
	[key: string]: any;
	
	public sourceTag: string;
	public destinationTag: string;
	public amount: number;
    
	constructor(){
		super();
		this.sourceTag = '';
		this.destinationTag = '';
		this.amount = 0;
		
	}
	getProperties(){
		return FreeProductPlanSettingDtoModel.classProperties;
	}
}

